<template>
  <transition name="fade" appear>
    <a :class="{ 'alternate-theme': alternateTheme }" v-if="external || link[0] === '#'" :href="link">
      <span>{{ text }}</span>
    </a>
    <button :class="{ 'alternate-theme': alternateTheme }" v-else>
      <span>{{ text }}</span>
    </button>
  </transition>
</template>

<script>
  export default {
    name: "TimeButton",
    props: {
      text: String,
      link: String,
      alternateTheme: Boolean,
      external: Boolean,
    },
  };
</script>

<style lang="scss" scoped>

  a,
  button {
    cursor: pointer;
    text-decoration: none;
    border-radius: 2px;
    border: 1px solid #D1D1D1;
    background: var(--white);
    padding: 10px 16px;
    user-select: none;
    color: var(--black);
    transition:all 0.2s ease-out;

    span {
      text-align: center;
      font-family: "proxima-nova", sans-serif;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.32px;
      text-transform: uppercase;
    }

    &.disabled {
      display: none;
    }

    &.selected {
      background: var(--green);
      color:var(--white);
    }

    @media (hover: hover) {
      &:not(.disabled) {
        &:hover {
          background: var(--green);
          color:var(--white);
        }
      }
    }
  }
</style>